import { LoadingState } from './types.js';
import { LOADING_ANIMATION_OPTIONS, SUCCESS_ANIMATION_OPTIONS, ERROR_ANIMATION_OPTIONS, FOOD_LOOP_ANIMATION_OPTIONS } from './constants.js';

var animationForState = function animationForState(state) {
  switch (state) {
    case LoadingState.FoodLoop:
      return FOOD_LOOP_ANIMATION_OPTIONS;

    case LoadingState.Error:
      return ERROR_ANIMATION_OPTIONS;

    case LoadingState.Success:
      return SUCCESS_ANIMATION_OPTIONS;

    case LoadingState.Loading:
    default:
      return LOADING_ANIMATION_OPTIONS;
  }
};
var keyForState = function keyForState(state) {
  switch (state) {
    case LoadingState.FoodLoop:
      return 'FOOD_LOOP';

    case LoadingState.Error:
      return 'ERROR';

    case LoadingState.Success:
      return 'SUCCESS';

    case LoadingState.Loading:
    default:
      return 'LOADING';
  }
};

export { animationForState, keyForState };
